<mat-form-field *ngIf="outlined" appearance="outline" class="outlined-field">
  <mat-label>{{ label }}</mat-label>
  <input
    *ngIf="!multiline"
    matInput
    [attr.data-testid]="testId || null"
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="qsInputControl"
    [required]="required"
  />
  <textarea
    *ngIf="multiline"
    matInput
    [attr.data-testid]="testId || null"
    [placeholder]="placeholder"
    [formControl]="qsInputControl"
    [required]="required"
    [rows]="rows"
  ></textarea>
</mat-form-field>

<div *ngIf="!outlined" class="group" [class.multiline]="multiline">
  <label>{{ label }}</label>
  <input
    *ngIf="!multiline"
    [attr.data-testid]="testId || null"
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="qsInputControl"
    [required]="required"
  />
  <textarea
    *ngIf="multiline"
    [attr.data-testid]="testId || null"
    [placeholder]="placeholder"
    [formControl]="qsInputControl"
    [required]="required"
    [rows]="rows"
  ></textarea>
  <div
    *ngIf="qsInputControl.invalid && !qsInputControl.dirty"
    [class.dirty]="qsInputControl.dirty"
  >
    <div>{{ 'qs.input.required' | translate }}</div>
  </div>
</div>
